import { getHereApiKeyForFleetMap } from '@backoffice-frontend/here-maps-api'
import H from '@here/maps-api-for-javascript'

type MapLayer = { map: H.map.layer.Layer }
type DefaultLayers = { vector: { normal: MapLayer; traffic: MapLayer } }
type Platform = Omit<H.service.Platform, 'createDefaultLayers'> & {
  createDefaultLayers: () => DefaultLayers
}

// HERE Maps types are incomplete
export const platform = new H.service.Platform({
  apikey: getHereApiKeyForFleetMap(),
}) as Platform
